const TOUR_STORAGE_PREFIX = "aq_esource_form_mgmt_tour_v1";

export function getEsourceFormMgmtTourStorageKey(staffId) {
  const id = String(staffId || "").trim();
  return id ? `${TOUR_STORAGE_PREFIX}_${id}` : TOUR_STORAGE_PREFIX;
}

export function hasCompletedEsourceFormMgmtTour(staffId) {
  try {
    return localStorage.getItem(getEsourceFormMgmtTourStorageKey(staffId)) === "1";
  } catch {
    return false;
  }
}

export function markEsourceFormMgmtTourCompleted(staffId) {
  try {
    localStorage.setItem(getEsourceFormMgmtTourStorageKey(staffId), "1");
  } catch {
    /* ignore quota errors */
  }
}
